module.exports = __webpack_public_path__ + "static/img/banners_ir_cn.c4af3cdb.jpg";